import { z } from 'zod';
import { DiagnosticProgress } from '@/diagnostic/domain/Diagnostic.ts';
import { Progress } from '@/generic/progress';

const diagnosticInProgressSchema = z.object({
  progress: z.number().int().min(0).max(100),
});

export type CleanApiDiagnosticInProgressJson = z.infer<typeof diagnosticInProgressSchema>;

export const parseJsonToDiagnosticInProgress = (json: unknown): DiagnosticProgress =>
  DiagnosticProgress.of({
    progress: Progress.of(diagnosticInProgressSchema.parse(json).progress).orThrow(),
  });
